import { defineMessages } from "react-intl";

const messages = defineMessages({
    loading: {
        id: "general.loading",
    },
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    createScoreTooltip: {
        id: "score.saveTooltip",
    },
});

export default messages;
